import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import InputBox from "../../AdminPanel/Component/UI/InputBox";
import { MdOutlineEdit } from "react-icons/md";
import moment from 'moment';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      saveSuccess: false,
      formData: {
        name: "",
        email: "",
        country: "",
        postcode: "",
        mobile: "",
        organisation: ""
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.assessment.userAssessmentUserProfileData !==
      this.props.assessment.userAssessmentUserProfileData
    ) {
      const data = this.props.assessment.userAssessmentUserProfileData || {};
      this.setState({ formData: { ...data } });
    }
  }

  handleChange = (value, name) => {
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value }
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.updateUserDetails();
  };

  updateUserDetails = () => {
    const { formData } = this.state;
    let data = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      country: formData.country,
      postcode: formData.postcode
    }
    this.props.dispatch(assessmentActions.updateAssessmentUserProfile(data));
    this.setState({ saveSuccess: true, isEditing: false });
    setTimeout(() => this.setState({ saveSuccess: false }), 4000);
  };

  toggleEditing = () => {
    const { userAssessmentUserProfileData } = this.props.assessment;
    if (!this.state.isEditing && userAssessmentUserProfileData) {
      this.setState({ formData: { ...userAssessmentUserProfileData } });
    }
    this.setState((prev) => ({ isEditing: !prev.isEditing }));
  };


  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };


  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };



  render() {
    let { assessment } = this.props;
    const { formData, isEditing } = this.state;
    let { userAssessmentUserProfileData, loading } = assessment;

    const user = assessment.userAssessmentUserProfileData || {};
    const getUserDetails = (field) => user[field] || "0";

    // function getUserDetails(field) {
    //   return (field && userAssessmentUserProfileData && userAssessmentUserProfileData[field] ? userAssessmentUserProfileData[field] : "NA")
    // }

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };
    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };


    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="bg-white">
          {/* Cover */}
          {/* <section className="relative pt-40">
            <img src="https://pagedone.io/asset/uploads/1705473908.png" alt="cover" className="w-full absolute top-0 left-0 z-0 h-60 object-cover" />
            <div className="w-full mx-auto px-6 md:px-8 relative z-10">
              <div className="flex items-center justify-start mb-5">
                <div className="bg-gray-200 w-32 h-32 border-4 border-white rounded-full text-center flex justify-center items-center shadow-md">
                  <p className="text-5xl font-medium uppercase">Hr</p>
                </div>
              </div>
            </div>
          </section> */}

          <section className="relative pt-24">
            <div className="absolute top-0 left-0 w-full h-40 bg-gradient-to-r from-[#CFD8DC] to-[#ECEFF1] z-0" />
            <div className="w-full mx-auto px-6 md:px-8 relative z-10">
              <div className="flex items-center justify-start mb-5">
                <div className="bg-[#D1D5DB] backdrop-blur-sm w-32 h-32 border-4 border-white rounded-full flex justify-center items-center shadow-lg">
                  <p className="text-5xl font-semibold textblack uppercase">HR</p>
                </div>
              </div>
            </div>
          </section>

          {/* Header */}
          <div className="flex justify-between w-full mt-6">
            <h1 className="md:text-2xl text-xl text-[#3D405B]">My Profile</h1>
            <button onClick={this.toggleEditing} className="textblack flex items-center space-x-2 bg-white border border-[#D1D5DB] rounded px-4 py-1.5">
              <MdOutlineEdit size={22} />
              <span>{isEditing ? "Cancel" : "Edit"}</span>
            </button>
          </div>

          <div className="border-b mb-8 mt-4">
            <button className="pb-2 border-b-2 border-blue-600 text-blue-600 font-medium">
              Personal Details
            </button>
          </div>

          <h2 className="md:text-2xl text-xl text-[#3D405B] mb-6">Personal Information</h2>

          {isEditing ? (
            <form className="space-y-6" onSubmit={this.handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputBox label="Full Name" name="name" value={formData.name} onChange={(e) => this.handleChange(e.target.value, "name")} />
                <InputBox label="Email Address" disabled name="email" value={formData.email} onChange={(e) => this.handleChange(e.target.value, "email")} />
                <InputBox label="Mobile" name="mobile" value={formData.mobile} onChange={(e) => this.handleChange(e.target.value, "mobile")} />
                <InputBox label="Organisation" name="organisation" value={formData.organisation} onChange={(e) => this.handleChange(e.target.value, "organisation")} />
                <InputBox label="Country" name="country" value={formData.country} onChange={(e) => this.handleChange(e.target.value, "country")} />
                <InputBox label="Postal Code" name="postcode" value={formData.postcode} onChange={(e) => this.handleChange(e.target.value, "postcode")} />
              </div>

              <div className="flex gap-4 pt-4">
                <button type="button" onClick={this.toggleEditing} className="px-5 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50">
                  Cancel
                </button>
                <button type="submit" className="px-6 py-2 rounded-md bgcolor  text-white hover:bg-blue-700">
                  Save Changes
                </button>
              </div>
            </form>
          ) : (
            <div className="space-y-6 textblack">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Info label="Full Name" value={getUserDetails("name")} />
                <Info label="Email" value={getUserDetails("email")} />
                <Info label="Mobile" value={getUserDetails("mobile")} />
                <Info label="Organisation" value={getUserDetails("organisation")} />
                <Info label="Country" value={getUserDetails("country")} />
                <Info label="Postal Code" value={getUserDetails("postcode")} />
              </div>
            </div>
          )}
        </div>
      </Dashboard>
    );
  }
}

const Info = ({ label, value }) => (
  <div className="">
    <label className="text-sm font-medium textblack">{label}</label>
    <p className="mt-0.5 w-full textblack border border-[#D1D5DB] rounded-md px-4 py-2 focus:ring-2 focus:ring-[#1976D2] outline-none disabled:bg-gray-100">{value}</p>
  </div>
);


function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { assessment } = state;
  return {
    loggingIn,
    assessment
  };
}

export default connect(mapStateToProps)(Account);
